<template>
  <div class="SectionMonthSearchPanel">
    <div>
      <box :title="this.$t('search')" class="card">
        <div class="px-3 pt-2">
          <table>
            <tbody>
              <tr>
                <td>
                  <label>{{ $t("year") }} : </label>
                </td>
                <td>
                  <v-select hide-details="" v-model="year" :items="years" :label="$t('year')" item-text="Name"
                     return-object dense solo v-on:change="changeYear" class="my-auto pa-0"></v-select>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("month") }} : </label>
                </td>
                <td>
                  <v-select hide-details="" v-model="month" :items="months" :label="$t('month')" dense solo @change="changeMonth"
                    class="my-auto pa-0"></v-select>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("sectionType") }} : </label>
                </td>
                <td>
                  <v-select hide-details v-model="sectionType" :items="sectionTypes" :label="$t('sectionType')"
                    item-text="Name" item-value="Code" return-object dense solo v-on:change="changeSectionType"
                    class="my-auto py-0"></v-select>
                </td>
              </tr>
            </tbody>
          </table>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
          </v-card-actions>
        </div>
      </box>
    </div>
  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
export default {
  data() {
    return {
      year: {},
      month: "",
      years: [],
      months: [],
      sectionType: "",
      sectionTypes: [],
    };
  },
  mounted() {
    this.getYears();
    this.getSectionTypes();
  },
  methods: {
    getYears() {
      this.$store
        .dispatch("GetEosMonthlyYearsList")
        .then((result) => {
          if (result.type === "success") {
            var data = [];
            data = result.data;
            this.years = data;
            console.log(this.years);
            if (this.years.length > 0) {
              this.year = this.years[this.years.length - 1];
              this.getPeriods();
            }
          } else {
            /*this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });*/
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
      return [];
    },
    changeYear() {
      //this.year = e.Name
      this.getPeriods();
    },
    changeMonth(){
      this.search();
    },
    getPeriods() {
      if (this.year == {}) {
        return;
      }

      const params = new URLSearchParams();
      params.append("year", this.year.Name);

      this.$store
        .dispatch("GetEosMonthList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            //if (data.length > 0) {
            this.months = data;
            if (this.months.length > 0) {
              debugger;
              var moment = require("jalali-moment");
              var month = moment().locale("fa").format("MM");
              // let today = new Date();
              // this.month = this.months[0]
              // this.month =parseInt(month.replace("0",""));
              this.month =parseInt(month.replace(/^0+/,""));
              this.search();
            }

            //}
          } else {
            /*this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });*/
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
      return [];
    },
    async getSectionTypes() {
      var params = new URLSearchParams();
      params.append("accessTo", 15);

      this.$store.dispatch("sections/GetSectionsList", { params }).then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        }
      });
    },

    changeSectionType() {
      this.search();
    },
    search() {
      var searchParams = {
        sectioncode: this.sectionType?.Code?.toString().trim() || "-1",
        year: this.year.Name,
        month: this.month,
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style>
</style>